var map = {
	"./pr-1.png": "004f",
	"./pr-2.png": "235a",
	"./pr-3.png": "6f38f",
	"./pr-4.png": "e587",
	"./pr-5.png": "b544",
	"./pr-6.png": "5b46",
	"./pr-7.png": "6912"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf25";